export { default as forty } from './forty';
export { default as sixty } from './sixty';
export { default as onetwenty } from './onetwenty';
export { default as oneighty } from './oneighty';
export { default as twoforty } from './twoforty';
export { default as others } from './others';

export const FILTERS = [
  {
    key: 'all',
    value: 'all' 
  },
  {
    key: '40',
    value: '40px' 
  },
  {
    key: '60',
    value: '60px' 
  },
  {
    key: '120',
    value: '120px' 
  },
  {
    key: '180',
    value: '180px' 
  },
  {
    key: '240',
    value: '240px' 
  },
  {
    key: 'other',
    value: 'others' 
  }
];

export const FILTERKEYS = {
  '40'       : '40 px',
  '60'       : '60 px',
  '120'      : '120 px',
  '180'      : '180 px',
  '240'      : '240 px',
  other      : 'Others',
};



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/index.js